import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Loader2, ClipboardList, Star } from 'lucide-react';
import { ConsumerLayout } from '@/components/consumer/ConsumerLayout';
import { useOSConsumer } from '@/hooks/useConsumerOS';
import { estadoOSConsumer } from '@/lib/consumer-os';
import { formatarMoeda } from '@/lib/currency';

export default function ConsumerServicos() {
  const { t } = useTranslation();
  const { data, isLoading } = useOSConsumer();

  return (
    <ConsumerLayout>
      <h1 className="text-xl font-bold mb-4">{t('myOrders.title')}</h1>
      {isLoading ? (
        <div className="flex justify-center py-16"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>
      ) : (data ?? []).length === 0 ? (
        <div className="flex flex-col items-center text-center gap-2 py-16 text-muted-foreground">
          <ClipboardList className="h-10 w-10" />
          <p className="text-sm max-w-xs">{t('myOrders.empty')}</p>
        </div>
      ) : (
        <ul className="flex flex-col gap-2">
          {(data ?? []).map((os) => {
            const e = estadoOSConsumer(os.status);
            return (
              <li key={os.os_id}>
                <Link to={`/app/servicos/${os.os_id}`} className="ow-card p-3 flex items-center gap-3 hover:border-primary transition-colors">
                  {os.empresa.logo_url
                    ? <img src={os.empresa.logo_url} alt="" className="h-10 w-10 rounded-lg object-cover" />
                    : <div className="h-10 w-10 rounded-lg bg-muted flex items-center justify-center font-bold">{(os.empresa.nome[0] ?? '?').toUpperCase()}</div>}
                  <div className="min-w-0 flex-1">
                    <div className="font-medium truncate">{os.empresa.nome}</div>
                    <div className="text-xs text-muted-foreground truncate">{os.servicos.join(', ') || os.numero_os}</div>
                  </div>
                  <div className="flex flex-col items-end gap-1">
                    <span className={`text-xs px-2 py-0.5 rounded-full ${e.classe}`}>{t(e.labelKey)}</span>
                    {os.ja_avaliada && <span className="text-xs text-yellow-500 flex items-center gap-0.5"><Star className="h-3 w-3 fill-current" />{t('myOrders.ratedShort')}</span>}
                    {os.valor_total != null && <span className="text-xs text-muted-foreground">{formatarMoeda(os.valor_total)}</span>}
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </ConsumerLayout>
  );
}
